import React from 'react';
import { connect } from 'react-redux';
import { Creators as TaskCreators } from 'store/ducks/task';

import Modal from 'components/Modal';

const CancelQuoteModal = ({
  cancelModalIsOpen, setCancelModalIsOpen, quoteCanceled, _setQuoteCanceledRequest, _setQuoteCanceledSuccess, taskQuoteProDetail, taskDetail, _getTaskDetail,
}) => (
  <Modal
    isOpen={cancelModalIsOpen}
    toggle={() => setCancelModalIsOpen(!cancelModalIsOpen)}
    title="Cancelar Contratação"
    // disabled={!selectedTaskOption}
    footer={quoteCanceled ? 'Fechar' : 'Confirmar Cancelamento'}
    footerClick={quoteCanceled ? () => {
      _getTaskDetail(taskDetail.id);
      setCancelModalIsOpen(!cancelModalIsOpen);
      _setQuoteCanceledSuccess(false);
    } : () => _setQuoteCanceledRequest({ quoteId: taskQuoteProDetail.id })}
  >
    {quoteCanceled ? (
      <p>Contratação cancelada com sucesso</p>
    ) : (
      <p>Ao cancelar a contratação, você pode perder o valor combinado com o profissional. Lembre-se de não cancelar o serviço faltando pouco tempo para a execução, em respeito a agenda reservada do profissional.</p>
    )}
  </Modal>
);

const mapStateToProps = state => ({
  // taskDetail: state.task.taskDetail,
  quoteCanceled: state.task.quoteCanceled,
});

const mapDispatchToProps = {
  _getTaskDetail: TaskCreators.getTaskDetailRequest,
  _setQuoteCanceledRequest: TaskCreators.setQuoteCanceledRequest,
  _setQuoteCanceledSuccess: TaskCreators.setQuoteCanceledSuccess,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CancelQuoteModal);
